import {
  switchMap,
  withLatestFrom,
  mergeMap,
  catchError,
} from 'rxjs/operators';
import { BidPanelActionEnum, IHideBidPanelAction, ISubmitBidAction } from '.';
import {
  BidService,
  BidStatus,
  IAuction,
  IBidResultDetail,
} from '../../services';
import { ofType } from 'redux-observable';
import {
  DraftBidFailedAction,
  SubmitBidFailedAction,
  SubmitBidSuccessAction,
} from './ActionCreator';
import { IApplicationState } from '..';
import { EMPTY, concat, forkJoin, of } from 'rxjs';
import { UpdateAuctionWithBidResultAuction } from '../Auction/ActionCreator';

const bidService = new BidService();

export const submitBidEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(BidPanelActionEnum.SubmitBid),
    withLatestFrom(state$),
    mergeMap(([action, state]: [ISubmitBidAction, IApplicationState]) => {
      return bidService.bidSubmission(action.state?.bidCreation).pipe(
        switchMap((result : IBidResultDetail) => {
          if(!state.auction.data){
            return EMPTY;
          }
          return forkJoin([of(result), of(state.auction.data)]);
        }),
        mergeMap((x: [IBidResultDetail, IAuction[]]) => {
          const auctionsUpdated = x[1].map((auction) => {
            if (x[0].bidResult.documentId === auction.identification) {
              auction.bidStatus = x[0].successfullyBidResult?.status ?? x[0].bidResult.status;
              auction.bidResult = x[0].bidResult;
              auction.hasSuccessfullyBid = x[0].hasSuccessfullyBid;
              auction.successfullyBidResult = x[0].successfullyBidResult;
            }
            return auction;
          });
          return concat([
            SubmitBidSuccessAction(x[0].bidResult),
            UpdateAuctionWithBidResultAuction(auctionsUpdated || []),
          ]);
        }),
        catchError((x) => {
          console.error(x);
          return of(SubmitBidFailedAction(BidStatus.ServerError));
        })
      );
    })
  );

export const draftBidEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(BidPanelActionEnum.HideBidPanel),
    withLatestFrom(state$),
    mergeMap(([action, state]: [IHideBidPanelAction, IApplicationState]) => {
      return bidService.bidSubmission(action.state?.bidCreation).pipe(
        switchMap((result : IBidResultDetail) => {
          if(!state.auction.data){
            return EMPTY;
          }
          return forkJoin([of(result), of(state.auction.data)]);
        }),
        mergeMap((x: [IBidResultDetail, IAuction[]]) => {
          const auctionsUpdated = x[1].map((auction) => {
            if (x[0].bidResult.documentId === auction.identification) {
              auction.bidStatus = x[0].bidResult.status;
              auction.bidResult = x[0].bidResult;
              auction.hasSuccessfullyBid = x[0].hasSuccessfullyBid;
              auction.successfullyBidResult = x[0].successfullyBidResult;
            }
            return auction;
          });
          return concat([
            SubmitBidSuccessAction(x[0].bidResult),
            UpdateAuctionWithBidResultAuction(auctionsUpdated || []),
          ]);
        }),
        catchError((x) => {
          console.error(x);
          return of(DraftBidFailedAction(BidStatus.DraftFailed));
        })
      );
    })
  );
